import * as R from 'ramda';
export const jsonLinter = (view) => {
    const stringCode = view.state.doc.toString();
    if (!stringCode)
        return [];
    try {
        JSON.parse(stringCode);
    }
    catch (err) {
        return lintJsonParseErrors(err, view);
    }
    return [];
};
export function lintJsonParseErrors(e, view) {
    const pos = getPositionFromString(e, view.state.doc);
    return [
        {
            from: pos,
            message: R.propOr('Could not parse code', 'message', e),
            severity: 'error',
            to: pos,
        },
    ];
}
export function lintYamlParseErrors(e) {
    return [
        {
            from: R.pathOr(0, ['source', 'range', 'start'], e),
            message: R.propOr('Could not parse code', 'message', e),
            severity: 'error',
            to: R.pathOr(0, ['source', 'range', 'end'], e),
        },
    ];
}
export function getPositionFromString(error, doc) {
    const message = R.prop('message', error);
    const m = message.match(/at position (\d+)/);
    return m ? Math.min(+m[1], doc.length) : 0;
}
